module.exports = __webpack_public_path__ + "ef74458ad8d5e41785d89942a2b62e78.pdf";